import { render, staticRenderFns } from "./AffiliatesWithSelectors.vue?vue&type=template&id=4c171707&"
import script from "./AffiliatesWithSelectors.vue?vue&type=script&lang=js&"
export * from "./AffiliatesWithSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports